import useGet from "../useGet";
import isArray from "../../utils/isArray";

const useBranches = () => {
  const { value, loading } = useGet(
    "/api/Branches?ts=" + new Date().getTime(),
    "Unable to read branches",
    null,
    undefined,
    undefined,
    undefined,
    (v: any) => v == null || isArray(v)
  );

  return {
    branches: value,
    branchesLoading: loading
  };
};

export default useBranches;
